'use strict';

import $ from 'jquery';
import { FormDonation } from './form-donation';
import { Steps } from './steps';

const JS_CLASS = 'js-donation';

const Donation = (htmlElement) => {
  const donation = {
    dom: {
      $el: null,
      $phases: null,
      $activatePhase2Btn: null,
      $activatePhase1Btn: null,
      $formHolders: null
    },
    forms: {
      commonForm: null,
      donationForms: []
    },
    // Possible common fields, every form doesn't need to support all of these
    // use `js-donation__common-field` class on input to add dynamically. these are for backwards compatibility
    commonFields: ['donation', 'other_sum', 'first_name', 'last_name'],
    // Field used to identify F2F seller
    sellerField: 'seller_mepco_id',
    // Default form select field. Can be overriden with `js-donation__form-select-field` class on input
    formSelectField: 'recurring_payment_method',
    // phases || open
    formMode: 'phases',
    phase2NameField: 'first_name',
    phaseStatus: {
      1: {
        disabled: false
      }
    },
    steps: null,
    activePhase: 1,
    initButtons() {
      this.dom.$activatePhase1Btn = this.dom.$el.find('.' + JS_CLASS + '__activate-phase-1');
      this.dom.$activatePhase2Btn = this.dom.$el.find('.' + JS_CLASS + '__activate-phase-2');

      this.dom.$activatePhase1Btn.on('click', () => {
        this.setActivePhase(1);
      });

      this.dom.$activatePhase2Btn.on('click', () => {
        this.setActivePhase(2);
      });
    },
    initSteps() {
      this.steps = new Steps('.' + JS_CLASS + '__steps');
    },
    initPhases() {
      this.dom.$phases = this.dom.$el.find('.' + JS_CLASS + '__phase');
    },
    initOtherElements() {
      this.dom.$phase2Text = this.dom.$el.find('.' + JS_CLASS + '__phase-2-text');
      this.dom.$phase2Name = this.dom.$el.find('.' + JS_CLASS + '__phase-2-name');
      this.dom.$badgeSum = this.dom.$el.find('.' + JS_CLASS + '__badge-sum');
    },
    updatePhase2Name() {
      const name = this.forms.commonForm.getFieldValue(this.phase2NameField)

      if(name && this.dom.$phase2Text.length) {
        this.dom.$phase2Text.addClass('has-name');
        this.dom.$phase2Name.text(`${ name }, `);
      }
    },
    getDonationSum() {
      // Get existing common field values
      const commonValues = this.forms.commonForm.getFieldValues(this.commonFields);

      if(commonValues.donation === 'other') {
        return commonValues.other_sum;
      }

      return commonValues.donation;
    },
    updateBadgeSum() {
      this.dom.$badgeSum.text(this.getDonationSum());
    },
    activateF2FMode() {
      this.formMode = 'open';
      // We need to keep seller field updated on all of the forms
      this.commonFields.push(this.sellerField);
    },
    activatePhase2Form(formName) {
      this.dom.$formHolders.each(function () {
        const $formHolder = $(this);

        if($formHolder.data('form') === formName) {

          $formHolder.addClass('is-active');
        } else if($formHolder.hasClass('is-active')) {
          $formHolder.removeClass('is-active');
        }
      });
    },
    updatePhase2Settings(options = {}) {
      this.phaseStatus[2] = options;
      // Set activate button disabled, if we have errors
      if(options.disabled) {
        this.dom.$activatePhase2Btn.prop('disabled', true);
      } else {
        this.updatePhase2Name();
        this.updateBadgeSum();
        this.dom.$activatePhase2Btn.prop('disabled', false);
      }

      if(options.form) {
        this.activatePhase2Form(options.form);
      }
    },
    setActivePhase(phaseNumber, isPopState = false) {
      // This phase is still disabled
      if (!this.phaseStatus[phaseNumber] || this.phaseStatus[phaseNumber].disabled) {
        history.replaceState({
          phase: this.activePhase
        }, '');
        return;
      }

      this.activePhase = phaseNumber;

      if (!isPopState && window.history && history.pushState) {
        history.pushState({
          phase: this.activePhase
        }, '', `#${ this.anchor }`); // Scroll to top of form with anchor
      }

      this.steps.setActiveStep(phaseNumber);

      this.dom.$phases.each(function () {
        const $phase = $(this);

        if(parseInt($phase.data('phase')) === phaseNumber) {
          $phase.addClass('is-active');
        } else if($phase.hasClass('is-active')) {
          $phase.removeClass('is-active');
        }
      });
    },
    /**
     * Allow copying data from previously filled fields to new fields
     * @param {Event} event change event
     * @param {htmlElement} form form element
     * @param {array} fields fields to copy
     */
    copyFieldValues(event, form, fields) {
      if (!fields) return;

      const copyFields = event.target.checked;

      fields.forEach(field => {
        const fieldFromCopy = form.querySelector(`[name="${field}"]`);
        const fieldToCopy = form.querySelector(`.js-form__copy-${field}`);
        if (fieldFromCopy && fieldToCopy) {
          if(copyFields) {
            this.copyFieldValue(fieldFromCopy, fieldToCopy);
            fieldFromCopy.addEventListener('change', this.onCopyFieldChange);
          } else {
            fieldFromCopy.removeEventListener('change', this.onCopyFieldChange);
          }
        }
      })
    },
    /**
    * On field change, update value to another field
    * @param {Event} event change event
    */
    onCopyFieldChange(event){
      const fieldName = event.currentTarget.name;
      const fieldToCopy = document.querySelector(`.js-form__copy-${fieldName}`);
      this.copyFieldValue(event.currentTarget, fieldToCopy);
    },
    /**
     * Copy field value to another
     * @param {htmlElement} fromField field to copy from
     * @param {htmlElement} toField field to copy to

     */
    copyFieldValue(fromField, toField){
      toField.value = fromField.value || '';
    },
    getCommonData() {
      // Get existing common field values
      const commonValues = this.forms.commonForm.getFieldValues(this.commonFields);
      let errors = this.forms.commonForm.getValidationErrors(this.commonFields);

      // Don't pass if donation === 'other' and other sum is not defined
      if(commonValues.donation === 'other' && !commonValues.other_sum) {
        errors = true;
      }

      // With open form we don't have to check for errors before proceeding to next step
      if(this.formMode === 'open') {
        errors = false;
      }

      const selectedFormName = this.forms.commonForm.getFieldValue(this.formSelectField);
      const selectedForm = this.forms.donationForms.find(form => form.name === selectedFormName);

      return {
        commonValues,
        errors,
        selectedFormName,
        selectedForm
      }
    },
    initFormValueReplication() {
      const { commonValues, errors, selectedFormName, selectedForm } = this.getCommonData();

      // Enable next phase if no error
      this.updatePhase2Settings({
        disabled: !!errors,
        form: selectedFormName
      });

      this.forms.donationForms.forEach(form => {
        form.updateFieldValues(commonValues);
      });

      // When ever common fields change, we update them to other forms also
      this.forms.commonForm.on('change', (name, value) => {
        if(this.commonFields.indexOf(name) !== -1) {
          this.forms.donationForms.forEach(form => {
            form.updateFieldValue(name, value);
          });
        }
        const { errors, selectedFormName } = this.getCommonData();

        // Enable next phase if no errors
        this.updatePhase2Settings({
          disabled: !!errors,
          form: selectedFormName
        });
      });

      if(this.formMode === 'open') {
        // Update initial values to other forms (after failed Post etc.)
        if(selectedForm) {
          const values = selectedForm.getFieldValues();
          this.forms.donationForms.filter(form => form !== selectedForm).forEach(form => {
            form.updateFieldValues(values);
          });
        }

        // When ever form fields change, we update them to other forms also
        // If user changes payment mode they don't have to fill in all fields again
        this.forms.donationForms.forEach(sourceForm => {
          sourceForm.on('change', (name, value) => {
            // Exclude common values
            if(this.commonFields.indexOf(name) === -1) {
              this.forms.donationForms.forEach(targetForm => {
                if(sourceForm !== targetForm) {
                  targetForm.updateFieldValue(name, value);
                }
              });
            }
          });
        });
      }
    },
    initFormHolders() {
      this.dom.$formHolders = this.dom.$el.find('.' + JS_CLASS + '__form-holder');
    },
    initForms() {
      const self = this;
      let commonFormFound = false;
      this.onCopyFieldChange = this.onCopyFieldChange.bind(this);

      this.dom.$el.find('.' + JS_CLASS + '__form').each(function () {
        const $form = $(this);

        // Init common fields
        if(!$form.data('form-name')) {
          // Only one commonForm allowed
          if(!commonFormFound) {
            commonFormFound = true;
          } else {
            throw Error('Only one common field form allowed for donation (form without `form-name` attribute)');
          }

          const form = new FormDonation(this);
          form.init();

          const sellerField = form.getFieldValue(self.sellerField);

          // Add possible common fields
          $form.find(`.${ JS_CLASS }__common-field`).each(function () {
            if(this.name && self.commonFields.indexOf(this.name) === -1) {
              self.commonFields.push(this.name);
            }
          });

          // Find field that determines phase 2 form (if any) and override default
          const formSelectField = $form.find(`.${ JS_CLASS }__form-select-field`).attr('name');

          if(formSelectField) {
            self.formSelectField = formSelectField;
          }

          // If this form is being used by f2f seller, we need to make some adjustments
          if(sellerField) {
            self.activateF2FMode();
          }

          self.forms.commonForm = form;


        } else {
          // Phase 2 forms
          const form = new FormDonation(this);
          form.name = $form.data('form-name');
          form.init();
          self.forms.donationForms.push(form);
        }

        //subscribe / muumin letter fields copy functionality
        const formElement = $form[0];
        const copyAddressField = formElement.querySelector('.js-donation__field-copy-address');
        if(copyAddressField) {
          copyAddressField.addEventListener('change', (e) => self.copyFieldValues(e, formElement, ['address', 'postal_code', 'post_office']));
        }
      });

      import('./donation-examples').then(({initDonationExamples}) => {
        // All forms should have common fields if they have multiple sections
        // Open forms only have one possible section, so we can use the first form item
        initDonationExamples(self.forms.commonForm || self.forms.donationForms[0]);
      });

      // Listen for back / forward history operations
      if (window.history && history.pushState) {
        window.addEventListener('popstate', (event) => {
          if(event && event.state && event.state.phase) {
            this.setActivePhase(event.state.phase, true);
          } if(event && !event.state) {
            // If no state data is present, we want the first phase
            this.setActivePhase(1, true);
          }
        });
      }
    }
  }

  donation.dom.$el = $(htmlElement);

  if(!donation.dom.$el.length) {
    return;
  }

  donation.anchor = donation.dom.$el.data('anchor');

  donation.initForms();
  donation.initFormHolders();

  // If no commonForm we don't have phases enabled and we don't need any checking (for now)
  if(!donation.forms.commonForm) {
    return;
  }

  donation.initButtons();
  donation.initOtherElements();
  donation.initFormValueReplication();

  donation.initSteps();
  donation.initPhases();

  const initialActivePhase = donation.dom.$el.data('active-phase');

  // Always initiates on phase 1
  if (window.history && history.pushState) {
    history.replaceState({
      phase: 1
    }, '', '');
  }

  // And activate current phase
  if(initialActivePhase && donation.formMode === 'phases') {
    donation.setActivePhase(parseInt(initialActivePhase));
  }

  return donation;
}

const initDonationElements = function () {
  $('.' + JS_CLASS).each(function () {
    Donation(this);
  });
}
export default Donation;
export { initDonationElements };
